<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable no-unused-vars -->
<template>
  <div class="card-body">
    <h4 id="header-attribute" class="card-title card-collapse">
      <span
        class="pointer"
        @click="
          attributeComponentModel.collapseState = !attributeComponentModel.collapseState
        "
        >Product Attribute</span
      >
      <!-- <span class="f-10 ml-2">Description Lorem Ipsom</span> -->
      <span class="f-10 ml-2">
        <b-icon
          icon="exclamation-circle-fill"
          variant="danger"
          animation="throb"
          font-scale="2"
          v-if="attributeComponentModel.validateState == false"
          @click="
            attributeComponentModel.collapseState = !attributeComponentModel.collapseState
          "
        ></b-icon>
      </span>
      <span class="icon-collapse">
        <!-- <i
          class="mdi mdi-comment-plus-outline text-danger i-add-comment font-size-18 mr-4"
          v-b-tooltip.hover
          title="Add comment"
          @click="addCommentClick"
        ></i> -->
        <button
          class="btn-icon-collapse"
          @click="
            attributeComponentModel.collapseState = !attributeComponentModel.collapseState
          "
        >
          <template>
            <i
              v-if="attributeComponentModel.collapseState"
              class="dripicons-minus"
            />
            <i v-else class="dripicons-plus" />
          </template>
        </button>
      </span>
    </h4>
    <b-collapse
      id="collapse-attribute"
      v-model="attributeComponentModel.collapseState"
      @input="modelChanged"
    >
      <validationObserver ref="componentForm" tag="form">
        <div class="pt-3">
          <div class="row">
            <div class="col-12">
              <div class="border-top pb-4"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-row form-group">
                <label
                  class="col-lg-4 col-xl-3 col-form-label"
                  for="productGroup"
                  >กลุ่มสินค้า</label
                >
                <div class="col-sm-4">
                  <validationProvider
                    v-slot="{ errors }"
                    name="productGroup"
                    :rules="
                      is_free ? {} : { validateDisplayNameObjectEng: true }
                    "
                  >
                    <attributeset-select
                      :isError="is_free ? false : errors.length > 0"
                      :hybridCategoryId="hybridCategoryId"
                      v-model="attributeComponentModel.model"
                      :isDisabled="
                        dataPermissions.find(f => f.name === 'attribute')
                          .isEditable === false
                      "
                    />

                    <span
                      v-if="is_free ? false : errors.length > 0"
                      class="validate-invalid"
                    >
                      {{ errors[0] }}
                    </span>
                    <span class="validate-textbox">
                      กรณีไม่มีกลุ่มสินค้ากรุณาติดต่อ MDSG ผู้ดูแลสินค้า
                    </span>
                  </validationProvider>
                </div>
              </div>
              <div
                v-for="(attributes, index) in attributesArray !== null &&
                attributesArray !== undefined &&
                requiredValueOptions &&
                requiredValueOptions.length > 0
                  ? attributesArray
                  : []"
                :key="index"
              >
                <div
                  class="form-row"
                  v-if="
                    requiredValueOptions &&
                      requiredValueOptions.some(f => f.id === attributes.id) &&
                      requiredValueOptions.find(f => f.id === attributes.id)
                        .type === 'Boolean'
                  "
                >
                  <label
                    :class="
                      `col-lg-4 col-xl-3 col-form-label ${
                        index == 0 && false ? 'mt-4' : ''
                      }`
                    "
                    :for="`material_${index}`"
                    >{{ attributes.display_name.th }}
                  </label>
                  <div class="col-sm-4">
                    <validationProvider
                      class="relative d-block form-group"
                      v-slot="{ errors }"
                      :name="`material_${index}`"
                      :rules="
                        requiredValueOptions.some(
                          f => f.id === attributes.id
                        ) &&
                        requiredValueOptions.find(f => f.id === attributes.id)
                          .is_required_value
                          ? {
                              validateAttributeValue: true,
                              dynamicRequired: ['กรุณาระบุข้อมูล'],
                            }
                          : {}
                      "
                    >
                      <b-form-radio-group
                        :id="`material_${index}`"
                        :name="`material_${index}`"
                        v-model="attributes.value"
                        :options="
                          attributes &&
                          requiredValueOptions.find(f => f.id === attributes.id)
                            .data_values &&
                          requiredValueOptions.find(f => f.id === attributes.id)
                            .data_values.length > 0
                            ? requiredValueOptions
                                .find(f => f.id === attributes.id)
                                .data_values.map(it => ({
                                  text: `${it.th} : ${it.en}`,
                                  value: it,
                                }))
                            : []
                        "
                        :disabled="
                          dataPermissions.find(f => f.name === 'attribute')
                            .isEditable === false
                        "
                      >
                        <b-form-invalid-feedback :state="!(errors.length > 0)">
                          <i class="fas fa-exclamation-circle"></i>
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-radio-group>
                      <!-- <attribute-value-select
                        :id="`material_${index}`"
                        :name="`material_${index}`"
                        :isError="errors.length > 0"
                        v-model="attributes.value"
                        :options="
                          attributes &&
                          requiredValueOptions.find(f => f.id === attributes.id)
                            .data_values &&
                          requiredValueOptions.find(f => f.id === attributes.id)
                            .data_values.length > 0
                            ? requiredValueOptions.find(
                                f => f.id === attributes.id
                              ).data_values
                            : []
                        "
                        :isDisabled="
                          dataPermissions.find(f => f.name === 'attribute')
                            .isEditable === false
                        "
                      /> -->

                      <!--          <span
                        v-if="errors.length"
                        class="validate-invalid"
                        style="top: 0px;"
                      >
                        {{ errors[0] }}
                      </span> -->
                    </validationProvider>
                  </div>
                  <div class="col-sm-4"></div>
                </div>
                <div
                  class="form-row"
                  v-else-if="
                    requiredValueOptions &&
                      requiredValueOptions.some(f => f.id === attributes.id) &&
                      requiredValueOptions.find(f => f.id === attributes.id)
                        .type === 'Dropdown'
                  "
                >
                  <label
                    :class="
                      `col-lg-4 col-xl-3 col-form-label ${
                        index == 0 && false ? 'mt-4' : ''
                      }`
                    "
                    :for="`material_${index}`"
                    >{{ attributes.display_name.th }}
                  </label>
                  <div class="col-sm-4">
                    <validationProvider
                      class="relative d-block form-group"
                      v-slot="{ errors }"
                      :name="`material_${index}`"
                      :rules="
                        requiredValueOptions.some(
                          f => f.id === attributes.id
                        ) &&
                        requiredValueOptions.find(f => f.id === attributes.id)
                          .is_required_value
                          ? {
                              validateAttributeValue: true,
                              dynamicRequired: ['กรุณาระบุข้อมูล'],
                            }
                          : {}
                      "
                    >
                      <attribute-value-select
                        :id="`material_${index}`"
                        :name="`material_${index}`"
                        :isError="errors.length > 0"
                        v-model="attributes.value"
                        :options="
                          attributes &&
                          requiredValueOptions.find(f => f.id === attributes.id)
                            .data_values &&
                          requiredValueOptions.find(f => f.id === attributes.id)
                            .data_values.length > 0
                            ? requiredValueOptions.find(
                                f => f.id === attributes.id
                              ).data_values
                            : []
                        "
                        :isDisabled="
                          dataPermissions.find(f => f.name === 'attribute')
                            .isEditable === false
                        "
                      />
                      <span
                        v-if="errors.length"
                        class="validate-invalid"
                        style="top: 0px;"
                      >
                        {{ errors[0] }}
                      </span>
                    </validationProvider>
                  </div>
                  <div class="col-sm-4"></div>
                </div>
                <div
                  class="form-row"
                  v-else-if="
                    requiredValueOptions &&
                      requiredValueOptions.some(f => f.id === attributes.id) &&
                      requiredValueOptions.find(f => f.id === attributes.id)
                        .type === 'Multiple Select'
                  "
                >
                  <label
                    :class="
                      `col-lg-4 col-xl-3 col-form-label ${
                        index == 0 && false ? 'mt-4' : ''
                      }`
                    "
                    :for="`material_${index}`"
                    >{{ attributes.display_name.th }}
                  </label>
                  <div class="col-sm-4">
                    <validationProvider
                      class="relative d-block form-group"
                      v-slot="{ errors }"
                      :name="`material_${index}`"
                      :rules="
                        requiredValueOptions.some(
                          f => f.id === attributes.id
                        ) &&
                        requiredValueOptions.find(f => f.id === attributes.id)
                          .is_required_value
                          ? {
                              validateAttributeValue: true,
                              dynamicRequired: ['กรุณาระบุข้อมูล'],
                            }
                          : {}
                      "
                    >
                      <attribute-value-select-multi
                        :id="`material_${index}`"
                        :name="`material_${index}`"
                        :isError="errors.length > 0"
                        v-model="attributes.value"
                        :options="
                          attributes &&
                          requiredValueOptions.find(f => f.id === attributes.id)
                            .data_values &&
                          requiredValueOptions.find(f => f.id === attributes.id)
                            .data_values.length > 0
                            ? requiredValueOptions.find(
                                f => f.id === attributes.id
                              ).data_values
                            : []
                        "
                        :isDisabled="
                          dataPermissions.find(f => f.name === 'attribute')
                            .isEditable === false
                        "
                      />
                      <span
                        v-if="errors.length"
                        class="validate-invalid"
                        style="top: 0px;"
                      >
                        {{ errors[0] }}
                      </span>
                    </validationProvider>
                  </div>
                  <div class="col-sm-4"></div>
                </div>
                <div
                  class="form-row"
                  v-else-if="
                    requiredValueOptions &&
                      requiredValueOptions.some(f => f.id === attributes.id) &&
                      requiredValueOptions.find(f => f.id === attributes.id)
                        .type === 'Text Area'
                  "
                >
                  <label
                    :class="
                      `col-lg-4 col-xl-3 col-form-label ${
                        index == 0 && false ? 'mt-4' : ''
                      }`
                    "
                    :for="`materialTH_${index}`"
                    >{{ attributes.display_name.th }}
                  </label>
                  <div class="col-sm-4">
                    <validationProvider
                      class="relative d-block form-group"
                      v-slot="{ errors }"
                      :name="`materialTH_${index}`"
                      :rules="
                        requiredValueOptions.some(
                          f => f.id === attributes.id
                        ) &&
                        requiredValueOptions.find(f => f.id === attributes.id)
                          .is_required_value
                          ? { dynamicRequired: ['กรุณาระบุข้อมูล'] }
                          : {}
                      "
                    >
                      <div role="group" class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">TH</div>
                        </div>
                        <textarea
                          :id="`materialTH_${index}`"
                          :name="`materialTH_${index}`"
                          type="text"
                          class="form-control"
                          v-model="attributes.value.th"
                          :class="{ 'is-invalid': errors.length }"
                          :disabled="
                            dataPermissions.find(f => f.name === 'attribute')
                              .isEditable === false
                          "
                        >
                        </textarea>
                        <span v-if="errors.length" class="validate-invalid">
                          {{ errors[0] }}
                        </span>
                      </div>
                    </validationProvider>
                  </div>
                  <div class="col-sm-4">
                    <validationProvider
                      class="relative d-block form-group"
                      v-slot="{ errors }"
                      :name="`materialEN_${index}`"
                      :rules="
                        requiredValueOptions.some(
                          f => f.id === attributes.id
                        ) &&
                        requiredValueOptions.find(f => f.id === attributes.id)
                          .is_required_value
                          ? { dynamicRequired: ['กรุณาระบุข้อมูล'] }
                          : {}
                      "
                    >
                      <div role="group" class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">EN</div>
                        </div>
                        <textarea
                          :id="`materialEN_${index}`"
                          :name="`materialEN_${index}`"
                          type="text"
                          class="form-control"
                          v-model="attributes.value.en"
                          :class="{ 'is-invalid': errors.length }"
                          :disabled="
                            dataPermissions.find(f => f.name === 'attribute')
                              .isEditable === false
                          "
                        >
                        </textarea>
                        <span v-if="errors.length" class="validate-invalid">
                          {{ errors[0] }}
                        </span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div
                  class="form-row"
                  v-else-if="
                    requiredValueOptions &&
                      requiredValueOptions.some(f => f.id === attributes.id) &&
                      requiredValueOptions.find(f => f.id === attributes.id)
                        .type === 'Text Field'
                  "
                >
                  <label
                    :class="
                      `col-lg-4 col-xl-3 col-form-label ${
                        index == 0 && false ? 'mt-4' : ''
                      }`
                    "
                    :for="`materialTH_${index}`"
                    >{{ attributes.display_name.th }}
                  </label>
                  <div class="col-sm-4">
                    <validationProvider
                      class="relative d-block form-group"
                      v-slot="{ errors }"
                      :name="`materialTH_${index}`"
                      :rules="
                        requiredValueOptions.some(
                          f => f.id === attributes.id
                        ) &&
                        requiredValueOptions.find(f => f.id === attributes.id)
                          .is_required_value
                          ? { dynamicRequired: ['กรุณาระบุข้อมูล'] }
                          : {}
                      "
                    >
                      <div role="group" class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">TH</div>
                        </div>
                        <input
                          :id="`materialTH_${index}`"
                          :name="`materialTH_${index}`"
                          type="text"
                          class="form-control"
                          v-model="attributes.value.th"
                          :class="{ 'is-invalid': errors.length }"
                          :disabled="
                            dataPermissions.find(f => f.name === 'attribute')
                              .isEditable === false
                          "
                        />
                        <span v-if="errors.length" class="validate-invalid">
                          {{ errors[0] }}
                        </span>
                      </div>
                    </validationProvider>
                  </div>
                  <div class="col-sm-4">
                    <validationProvider
                      class="relative d-block form-group"
                      v-slot="{ errors }"
                      :name="`materialEN_${index}`"
                      :rules="
                        requiredValueOptions.some(
                          f => f.id === attributes.id
                        ) &&
                        requiredValueOptions.find(f => f.id === attributes.id)
                          .is_required_value
                          ? { dynamicRequired: ['กรุณาระบุข้อมูล'] }
                          : {}
                      "
                    >
                      <div role="group" class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">EN</div>
                        </div>
                        <input
                          :id="`materialEN_${index}`"
                          :name="`materialEN_${index}`"
                          type="text"
                          class="form-control"
                          v-model="attributes.value.en"
                          :class="{ 'is-invalid': errors.length }"
                          :disabled="
                            dataPermissions.find(f => f.name === 'attribute')
                              .isEditable === false
                          "
                        />
                        <span v-if="errors.length" class="validate-invalid">
                          {{ errors[0] }}
                        </span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validationObserver>
    </b-collapse>
  </div>
</template>
<script>
import AttributeSetSelect from '@/components/attributesets/selector'
import AttributeValueSelect from '@/components/attributes/value-selector'
import AttributeValueSelectMulti from '@/components/attributes/value-selector-multi'
import attributesetsService from '@/helpers/service/attributesets-service'
// import { StatusEnum } from '@/enum/status.enum.js'
import { eventBus } from '@/main.js'

export default {
  name: 'Attribute',
  components: {
    'attributeset-select': AttributeSetSelect,
    'attribute-value-select': AttributeValueSelect,
    'attribute-value-select-multi': AttributeValueSelectMulti,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.attributeComponentModel
      },
    },
    is_free: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    hybridCategoryId: {
      type: String,
      default: () => {
        return ''
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      options_attributsets: [],
      isInternalSearch: true,
      isResetAfter: false,
      selectOptions: [],
      attributeComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: {
          id: '',
          display_name: { en: '', th: '' },
          attributes: [],
        },
      },
      isFirstWatchValue: true,
      tempDefailtValue: [],
      requiredValueOptions: [],
      permissions: [
        {
          name: 'attribute',
          ruleIDs: ['P1', 'P5'],
          isEditable: false,
        },
      ],
      attributesArray: [],
    }
  },
  created() {
    this.attributeComponentModel = this.value

    if (this.value.model && this.value.model.id && this.value.model.id !== '') {
      this.onGetAttributeSetsSelector(this.value.model.id)
    }

    // eslint-disable-next-line no-unused-vars
    eventBus.$on('collapse-attribute', text => {
      this.attributeComponentModel.collapseState = true
      this.onSubmit()
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.onSubmit()
    })
  },
  computed: {
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter(f => f.my_process_action.can_edit === true)
          .map(m => m.rule_id)

        permissions
          .filter(f => f.ruleIDs.some(s => ruleEditables.some(r => r === s)))
          .forEach(element => {
            element.isEditable = true
          })
      } else {
        permissions.forEach(element => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
    /*   attributesLocalModel() {
      const model = this.attributeComponentModel.
      return []
    }, */
  },
  watch: {
    attributesArray: {
      deep: true,
      // eslint-disable-next-line no-unused-vars
      handler(newValue, oldValue) {
        const newModel = this.changeAttributesModelToObject(newValue)
        this.attributeComponentModel.model.attributes = newModel
      },
    },
    'attributeComponentModel.model': {
      handler(val) {
        if (val) {
          // console.log('sss', val)
          // val.attributes.forEach(element => {
          //   console.log('ccc', this.tempDefailtValue)
          //   if (
          //     this.tempDefailtValue.some(f => f.id === element.id) &&
          //     this.tempDefailtValue.find(f => f.id === element.id).value &&
          //     this.tempDefailtValue.find(f => f.id === element.id).value.en !==
          //       ''
          //   ) {
          //     element.value = this.tempDefailtValue.find(
          //       f => f.id === element.id
          //     ).value
          //   } else if (element.value === undefined || element.value === null) {
          //     element.value = { en: '', th: '' }
          //   }
          // })
          this.onSubmit()
        }
      },
      deep: true,
    },
    'attributeComponentModel.model.id': {
      handler(id) {
        if (id && id !== '') {
          this.onGetAttributeSetsSelector(id)
        }
      },
      deep: true,
    },
    'attributeComponentModel.collapseState': {
      handler(val) {
        if (val) {
          this.onSubmit()
        }
      },
    },
    value: {
      handler(val) {
        if (this.isFirstWatchValue) {
          this.attributeComponentModel = val

          if (
            this.attributeComponentModel.model &&
            this.attributeComponentModel.model.attributes &&
            this.attributeComponentModel.model.attributes.length > 0
          ) {
            this.isFirstWatchValue = false
            // this.attributeComponentModel.model.attributes.forEach(element => {
            //   if (
            //     element &&
            //     element.value &&
            //     element.data_values &&
            //     element.data_values.length > 0 &&
            //     element.data_values.some(
            //       f => f.en === element.value.en && f.th === element.value.th
            //     )
            //   ) {
            //     element.value = element.data_values.find(
            //       f => f.en === element.value.en && f.th === element.value.th
            //     )
            //   } else {
            //     if (
            //       element.type === 'Dropdown' ||
            //       element.type === 'Multiple Select'
            //     ) {
            //       element.value = null
            //     }
            //   }
            // })
            if (
              this.attributeComponentModel.model.id &&
              this.attributeComponentModel.model.id !== ''
            ) {
              this.onGetAttributeSetsSelector(
                this.attributeComponentModel.model.id
              )
            }
          }
        }

        this.$nextTick(() => {
          this.onSubmit()
        })
      },
      deep: true,
    },
  },
  methods: {
    changeAttributesModelToArray(model) {
      // console.log(model)
      let newModel = []
      //console.log('model', ':', model)
      // eslint-disable-next-line no-unused-vars
      model.forEach((item, index, arr) => {
        const option = this.requiredValueOptions.find(it => it.id === item.id)
        if (!option) {
          return
        }
        if (option.type !== 'Multiple Select') {
          newModel = [...newModel, item]
          return
        }
        //console.log('Multiple Select', index, ':', item)
        const itemExistId = newModel.find(it => it.id === item.id)
        if (!itemExistId) {
          //console.log('Not itemExistId', index, ':', item)
          newModel = [...newModel, { ...item, value: [item.value] }]
          //console.log('newModel itemExistId', index, ':', newModel)
          return
        }
        //console.log('value', value)
        const value = item.value
        newModel = newModel.map(it =>
          it.id === item.id ? { ...it, value: [...it.value, value] } : { ...it }
        )
        return
      })
      // console.log('newModel', newModel)
      return newModel
    },
    changeAttributesModelToObject(model) {
      let newModel = []
      // eslint-disable-next-line no-unused-vars
      model.forEach((item, index, arr) => {
        const option = this.requiredValueOptions.find(it => it.id === item.id)
        if (!option) {
          return
        }
        if (option.type !== 'Multiple Select') {
          newModel = [...newModel, item]
          return
        }
        const value = item.value
        if (value.length <= 0) {
          newModel = [...newModel, { ...item, value: { en: '', th: '' } }]
        } else {
          // eslint-disable-next-line no-unused-vars
          value.forEach((item2, index2, arr2) => {
            newModel = [...newModel, { ...item, value: item2 }]
          })
        }
      })
      // console.log('newModel', newModel)
      return newModel
    },
    modelChanged() {
      this.attributeComponentModel.isPayloadChanged = true
      this.$emit('input', this.attributeComponentModel)
    },
    onSubmit() {
      this.$refs.componentForm.validate().then(result => {
        this.attributeComponentModel.validateState = this.is_free || result
        this.modelChanged()
      })
    },
    onReset() {},
    addCommentClick() {
      eventBus.$emit('regist_product_comment_click', this.$options.name)
    },
    async onGetAttributeSetsSelector(id) {
      this.requiredValueOptions = []
      let params = new URLSearchParams()
      params.append('pageSize', 99999)
      params.append('sort', 'display_name.en display_name.th')
      params.append('isGetIncludeAttributes', true)
      params.append('id', id)
      let result = await attributesetsService.getAttributeSetsMasterListAsync(
        params
      )
      if (result.status === 200 && result.data.items) {
        let options = []
        result.data.items[0].attributes.forEach((el, index) => {
          options[index] = {
            id: el.id,
            is_required_value: el.is_required_value,
            type: el.type,
            display_name: el.display_name,
            data_values:
              el.data_values && el.data_values.length > 0
                ? el.data_values.map(s => s.value)
                : [
                    {
                      th: '',
                      en: '',
                    },
                  ],
          }
        })
        this.requiredValueOptions = options

        this.attributesArray = this.changeAttributesModelToArray(
          this.value.model.attributes
        )

        this.$nextTick(() => {
          this.onSubmit()
        })
      } else {
        if (result.response.data.message) {
          // eslint-disable-next-line no-console
          console.log(result.response.data.message)
        }
      }
    },
  },
}
</script>
